module.exports = __webpack_public_path__ + "img/stacked-py-chart-guide.b723ee6.png";